import { useContext } from 'react';
import Context from './Context';

export default function useAccountApi() {
  const { account } = useContext(Context);
  return account;
}
